import React, { useEffect } from "react";
import { useHttp } from "../../../../hooks/useHttp";
import  { useToast } from "../../../Toast/Toast";
import PopUp from "../../../PopUp/PopUp";

const DeleteCell = ({ batteryId, openDeleteModal , setOpenDeleteModal, onDelete }) => {
    const { loading, sendRequest, error, clearError, data } = useHttp();
    const showToast = useToast();
    const handleDelete = async() => {
        await sendRequest(`batteries/id/${batteryId}`, "DELETE");
    };

    useEffect(() => {
        if (data) {
            onDelete(batteryId);
            showToast("Cell deleted successfully", "success");
            setOpenDeleteModal(false);
        }
      }
        , [data]);
    
      useEffect(() => {
        if (error) {   
            showToast(error, "error"); 
            setOpenDeleteModal(false);   
         }
      }, [error, clearError]);


    return (
        <PopUp
            title="Delete Cell"
            message="Are you sure you want to delete this cell?"
            open={openDeleteModal}
            setOpen={setOpenDeleteModal}
            yesText="Delete"
            noText="Cancel"
            yesColor="error"
            noColor="primary"
            handleYes={handleDelete}
            handleNo={() => setOpenDeleteModal(false)}            
        />
    );
};

export default DeleteCell;
